import {
    User,
    Mail,
    Phone,
    MapPin,
    CalendarDays,
    ShieldCheck,
} from "lucide-react";

import "./CustomerTab.css";

function CustomerTab({ order }) {

    return (

        <div className="customer-tab">

            {/* ================= PROFILE ================= */}

            <div className="customer-profile-card">

                <div className="customer-avatar">

                    {order.customerSnapshot?.name
                        ?.charAt(0)
                        ?.toUpperCase()}

                </div>

                <div className="customer-profile-info">

                    <h2>

                        {order.customerSnapshot?.name}

                    </h2>

                    <p>

                        Customer since

                        {" "}

                        {new Date(
                            order.createdAt
                        ).toLocaleDateString("en-IN")}

                    </p>

                </div>

            </div>

            {/* ================= DETAILS ================= */}

            <div className="customer-info-grid">

                <div className="info-card">

                    <Mail size={20}/>

                    <div>

                        <label>Email</label>

                        <h4>

                            {order.customerSnapshot?.email || "-"}

                        </h4>

                    </div>

                </div>

                <div className="info-card">

                    <Phone size={20}/>

                    <div>

                        <label>Phone</label>

                        <h4>

                            {order.customerSnapshot?.phone || "-"}

                        </h4>

                    </div>

                </div>

                <div className="info-card">

                    <MapPin size={20}/>

                    <div>

                        <label>Delivery Address</label>

                        <h4>

                            {order.addressSnapshot?.addressLine1}

                        </h4>

                        <span>

                            {order.addressSnapshot?.city},

                            {" "}

                            {order.addressSnapshot?.state}

                        </span>

                    </div>

                </div>

                <div className="info-card">

                    <CalendarDays size={20}/>

                    <div>

                        <label>Order Date</label>

                        <h4>

                            {new Date(order.createdAt).toLocaleString("en-IN")}

                        </h4>

                    </div>

                </div>

                <div className="info-card">

                    <ShieldCheck size={20}/>

                    <div>

                        <label>Status</label>

                        <h4>

                            Active Customer

                        </h4>

                    </div>

                </div>

                <div className="info-card">

                    <User size={20}/>

                    <div>

                        <label>Customer ID</label>

                        <h4>

                            {order.customerId?._id || order.customerId}

                        </h4>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default CustomerTab;